import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Task} from "../models/Task";
import {ApiPathsService} from "../../api-paths.service";
import {FileStoreService} from "../../shared/_services/file-store.service";
import {DatePipe} from "@angular/common";
import {environment} from "../../../environments/environment";
import {CampoAggiuntivo, CampoUtility} from "../../shared/models/campo-aggiuntivo";
import {ToastrService} from "ngx-toastr";
import { Permission } from 'src/app/Login/_guards/Permission';
import { AuthenticationService } from 'src/app/Login/_services/authentication.service';
import {ApiRestService as RmaApiRestService} from "../../rma/_services/api-rest.service";
import {Rma} from "../../rma/_Models/rma";
import { NewsComponent } from '../news/news.component';

@Component({
  selector: 'app-dynamic-task',
  templateUrl: './dynamic-task.component.html',
  styleUrls: ['./dynamic-task.component.scss']
})
export class DynamicTaskComponent implements OnInit {

  @Input() Item: any ={};
  @Output() ItemChange = new EventEmitter<any>();
  @Output() updated = new EventEmitter<Task>();
  @Input() DynamicFields: {
      type?: string,
      addButton?: boolean,
      restRoute?: string,
      Label?: string,
      Azioni?: any[],
      campi?: any[]
    sezioni?: any[],
  };
  @Input() CampiNascosti;
  environment = environment;
  DropdownSources: any = {};
  ResetFields: boolean = false;
  constructor(
    private apiPaths: ApiPathsService,
    private filestore: FileStoreService,
    private datepipe: DatePipe,
    private toastrService : ToastrService,
    public campoUtility: CampoUtility,
    public permission: Permission,
    private authSvc: AuthenticationService,
    private modalService: NgbModal,
    private rmaApiRest: RmaApiRestService
  ) { }

  ngOnInit(): void {
    this.Refresh();
  }
  Refresh(){
    if(this.Item?.id) {
      this.ResetFields = true
      this.apiPaths.ClassicPost(`${this.DynamicFields.restRoute}/get`, {id: this.Item.id}).subscribe(data => {
        if (!data) return;
        this.Item = data?.data ?? data;
        this.FormBuilder();
        this.filestore.SetListaFile(this.Item.files);
        this.filestore.SelectSection(this.DynamicFields.restRoute);
        setTimeout(() => {
          this.ResetFields = false;
        }, 100)
      })
    }
    else
      this.Item.data_inizio_prevista = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm')
  }

  FormBuilder(){
    this.DynamicFields?.sezioni?.forEach(sezione=>{
      sezione.campi?.forEach(campo=>{
        this.SetCampoSource(this.Item, campo);
      })
    })
    this.DynamicFields?.campi?.forEach(campo=>{
       this.SetCampoSource(this.Item, campo);
    })

  }

  SetCampoSource(item, campo){
    if((campo['type'] == 'checkboxArray' || campo['type'] == 'checkboxArrayMEXC') && (!campo['filter'] || item?.sedeObject?.clienteObject?.id)) {
      console.log(item[campo['oggetti'][0]]);
      this.rmaApiRest.GetCampiAggiuntiviRmas(item[campo['oggetti'][0]]?.filter(x => typeof x == 'number' ? true : x.risposta) ?? [], campo['oggetti'][0], campo['filter'] ? {id: item?.sedeObject?.clienteObject?.id} : null).subscribe(data => {
        item[campo['oggetti'][0]] = data;
      });
    }
    if(campo['source'] == 'PrioritaSource')
      this.apiPaths.ClassicGet('/rma/rma/priorita').subscribe(data => this.DropdownSources.PrioritaSource = data ?? []);

    if(campo['source'] == 'PeriodiSource'){
      this.apiPaths.ClassicGet('/rma/rma/periodi').subscribe(data=>{
        this.DropdownSources.PeriodiSource = data;
      })
    }
  }
  close(){
   // this.ngbActiveModal.dismiss();
  }
  save(close?: boolean) {
    this.Item.partecipanti = this.Item?.partecipantiObject?.map(x=>x.id)
    if(this.Item['clientiObject'])
      this.Item['clienti'] = this.Item['clientiObject'].map(x=> {return {id: x.id, letto: false}});
    if (this.Item.id)
      this.apiPaths.ClassicPost(`${this.DynamicFields.restRoute}/update`,this.Item).subscribe((data) =>this.saved(this.Item, close));
    else
      this.apiPaths.ClassicPost(`${this.DynamicFields.restRoute}/add`,this.Item).subscribe((data) => this.saved(data, close));
  }
  saved(data, close?:boolean){
    this.Item.id = data.id;
    this.updated.emit(this.Item);
    this.Refresh();
    if (close)
      this.close();
  }
  onFileChanged() {
    this.Refresh();
  }

  ChangeHandler(item: { OnChange: string; Event: any, CampoAggiuntivo?: CampoAggiuntivo }) {
    console.log("Changehandler: ", item);
    switch (item.OnChange ) {
      case 'OnFilesChange' :
        this.Refresh();
        break;
      case 'AddCatCom' :
        if(!this.Item['clientiObject'])  this.Item['clientiObject'] = [];
        if(this.Item['addCatCom'])  {
          this.apiPaths.ClassicPost('/anagrafica/clienti/list',{page: 0, size: 10}).subscribe(data=>{
            var clientiCatCom = data?.data?.filter(x=>x.tipiObject?.find(y=>y.id == this.Item['addCatCom']?.id))
            console.log(`Clienti di categoria ${this.Item['addCatCom']?.nome}`,clientiCatCom);
            console.log(`Task: `, this.Item);
            this.Item['clientiObject'] = [...this.Item['clientiObject'],...clientiCatCom];
            setTimeout(()=>{this.Item['addCatCom'] = null;}, 300);
          })

        }
        break;
      case 'OnDelete':
        this.Item['clientiObject'] = this.Item['clientiObject'].filter(x => x.id != item.Event.id);
        break;
      case 'OnTableEdit':
        var dynamicFields = this.campoUtility.getDynamicTaskSctructure(item?.CampoAggiuntivo?.tasktype?.toLocaleUpperCase())
        if(!dynamicFields) return;
        let Newsmodal = this.modalService.open(NewsComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<NewsComponent>Newsmodal.componentInstance).DynamicFields = dynamicFields;
        (<NewsComponent>Newsmodal.componentInstance).IsModal = true;
        (<NewsComponent>Newsmodal.componentInstance).Item = item.Event ?? new Task();
        (<NewsComponent>Newsmodal.componentInstance).updated.subscribe(data => {
          this.Refresh()
        });
        break;
    }
  }
  getparam(oggetto, param){
    return oggetto ? oggetto[param]: null;
  }
  customButton(selected, button: { type?: 'GET'| 'POST'| 'GOTO', restRoute?: string, preMex?: string, successMex?: string, parameter?: any[], preAlert: string, close?:boolean}) {
    if(this.Item['clientiObject'])
      this.Item['clienti'] = this.Item['clientiObject'].map(x=>x.id);
    if(selected && (!button?.preAlert || confirm(button.preAlert))){

      var filter ={};
      button.parameter?.forEach(param=>{
        var p = param?.parameter?.split('.');
        var parameter = Object.assign({}, selected)
        p?.forEach(el=>{
          parameter = this.getparam(parameter,el);
        })
        filter[param.nome] = param.value ?? parameter
      })
      if(button.restRoute.includes(':id') )
        button.restRoute = button.restRoute.replace(':id', this.Item.id)
      if(button.restRoute.includes(':token') )
        button.restRoute = button.restRoute.replace(':token', this.authSvc.currentUserValue?.access_token )
      if(button.preMex)
        this.toastrService.warning(button.preMex);
      if(button.type == 'GET' && button.restRoute)
        this.apiPaths.ClassicGet(button.restRoute).subscribe(data=>{
          if(button.successMex)
            this.toastrService.success(button.successMex);
          if(button.close)
            this.close();
          this.updated.emit(data);
          this.Refresh();

        })
      if(button.type == 'POST' && button.restRoute)
        this.apiPaths.ClassicPost(button.restRoute,filter).subscribe(data=>{
          if(button.successMex)
            this.toastrService.success(button.successMex);
          if(button.close)
            this.close();
          this.updated.emit(data);
          this.Refresh();

        })
      if(button.type == 'GOTO' && button.restRoute) {

        window.open(button.restRoute, '_blank');
        if(button.successMex)
          this.toastrService.success(button.successMex);
        if(button.close)
          this.close();
      }

    }

  }

  FilterHandler($event: {OnFilter: string; Event: any}) {

  }
}
